import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-lti-callback',
  templateUrl: './lti-callback.component.html',
  styleUrls: ['./lti-callback.component.scss']
})
export class LtiCallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }
  error;
  ngOnInit() {
    this.route.params.subscribe(param => {
      console.log(param);
      this.route.queryParams.subscribe(query => {
        if (query.return_type) {

          let message: any = {}
          Object.assign(message, param);
          Object.assign(message, query);
          console.log(message);
          window.parent.postMessage(message, '*');
        } else {
          this.error = JSON.stringify(query);
        }
      })
    })

  }

}
